export default __webpack_public_path__ + "static/media/16_pencil-2.36d221af.jpg";